import * as React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface ReprocessingIconProps {
  size?: number
  className?: string
  backgroundColor?: string
  iconColor?: string
}

/**
 * Reprocessing icon - displays a circular refresh/sync icon for reprocessing functionality
 * @param {ReprocessingIconProps} props - Component props including size, className, backgroundColor, and iconColor
 * @returns {React.ReactElement} SVG React element representing the reprocessing icon
 */
const ReprocessingIcon: React.FC<ReprocessingIconProps> = ({
  size = 56,
  className,
  backgroundColor = colors.REPROCESSING_BLUE,
  iconColor = colors.WHITE,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 88 88'
      fill='none'
      className={className}
    >
      <rect width='88' height='88' rx='44' fill={backgroundColor} />
      <path
        d='M44 25.3333V21.1567C44 20.1067 42.74 19.5933 42.0166 20.34L35.4833 26.85C35.0166 27.3167 35.0166 28.04 35.4833 28.5067L41.9933 35.0167C42.74 35.74 44 35.2267 44 34.1767V30C51.7233 30 58 36.2767 58 44C58 45.8433 57.65 47.64 56.9733 49.25C56.6233 50.09 56.88 51.0467 57.51 51.6767C58.7 52.8667 60.7066 52.4467 61.3367 50.8833C62.2 48.76 62.6666 46.4267 62.6666 44C62.6666 33.6867 54.3133 25.3333 44 25.3333ZM44 58C36.2766 58 30 51.7233 30 44C30 42.1567 30.35 40.36 31.0266 38.75C31.3766 37.91 31.12 36.9533 30.49 36.3233C29.3 35.1333 27.2933 35.5533 26.6633 37.1167C25.8 39.24 25.3333 41.5733 25.3333 44C25.3333 54.3133 33.6866 62.6667 44 62.6667V66.8433C44 67.8933 45.26 68.4067 45.9833 67.66L52.4933 61.15C52.96 60.6833 52.96 59.96 52.4933 59.4933L45.9833 52.9833C45.26 52.26 44 52.7733 44 53.8233V58Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default ReprocessingIcon
